import React from "react";
import "./AlternatingCards.scss";
import CardItem from "./CardItem/CardItem";

export default function AlternatingCards({ cards }) {
  return (
    <div className="alternating-cards">
      {cards.map((card, index) => (
        <CardItem
          title={card.title}
          key={card.title}
          description={card.description}
          image={card.image}
          buttonHref={card.buttonHref}
          buttonText={card.buttonText}
          reverse={index % 2 !== 0}
        />
      ))}
    </div>
  );
}
